import React from "react";
// ANT DESIGN COMPONENTS
import { Tooltip } from "antd";
// FONT AWESOME LIBRARY AND ICONS
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";

/**
 * The `<span className="generalStyles__inputLabel">` + optional info-icon
 * pair every OPC UA CDO field uses above its control (InputNumber, Select,
 * Switch, ...). Factored out because that pair is hand-written at every call
 * site that doesn't go through `OpcUaTextField` (which renders its own
 * label internally) — see SessionEditor / SecurityEditor's certificate
 * fields.
 */
export default function OpcUaFieldLabel({
  label,
  tooltip = undefined,
  required = false,
}: {
  label: string;
  /** Plain text or a richer node (e.g. an `EnumHelpTable`). */
  tooltip?: React.ReactNode;
  required?: boolean;
}) {
  return (
    <>
      {required && <span className="generalStyles__inputFlexRequired">*</span>}
      <span className="generalStyles__inputLabel">
        {label}
        {tooltip && (
          <Tooltip title={tooltip}>
            <FontAwesomeIcon icon={faCircleInfo} className="generalStyles__mlFix" />
          </Tooltip>
        )}
      </span>
    </>
  );
}
